module.exports = __webpack_public_path__ + "img/close.915e507c.png";